export default __webpack_public_path__ + "static/desktop-img-ef84d8a9c7c0336994c43d0467879e66.png";